import { getCalendarEventsCountIndex } from '../store/store';
import { OwaDate } from 'owa-datetime';

/**
 * Returns the number of calendar events for a given date
 * @param date Display date
 */
export default function getCalendarEventsCountForADay(date: OwaDate): number {
    return getCalendarEventsCountIndex().getEventsCount(date);
}
